import React from 'react';

import { Abstrap } from '../../..';
import PasswordSymbol from '../FormField/PasswordSymbol/PasswordSymbol';
import FormInput from '../FormInput/FormInput';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class FormInputPassword extends Abstrap {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.state = {
            visible: true,
        };
    }

    onClick() {
        if (this.state.visible) {
            this.setState({
                visible: false,
            });
        } else {
            this.setState({
                visible: true,
            });
        }
    }

    render() {
        const { visible } = this.state;
        return (
            <>
                <FormInput
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.filterProps(propTypes)}
                    type={visible ? 'password' : 'text'}
                />
                <PasswordSymbol
                    visible={visible}
                    onClick={this.onClick}
                />
            </>
        );
    }

}

FormInputPassword.propTypes = propTypes;

FormInputPassword.defaultProps = defaultProps;

export default FormInputPassword;
